import React, { useState, useEffect } from "react";
import { Col, Form } from "react-bootstrap";
import eye from "../assets/icons/eye.svg";
import offEye from "../assets/icons/off_eye.svg";

interface CustomFormInputProps {
  label: string;
  controlId: string;
  placeholder: string;
  register: any;
  validation?: any;
  error?: any;
  asCol?: boolean;
  value?: string | string[] | number;
  onChange?: (value: string) => void;
  inputType?: string;
  isEditable?: boolean;
  maxLength?: number;
  as?: string;
  rows?: number;
  borderRadius?: number;
  border?: string;
  fullWidth?: boolean;
  width?: string;
  onKeyDown?: (e: React.KeyboardEvent<HTMLInputElement | HTMLTextAreaElement>) => void;
  onInput?: (e: React.FormEvent<HTMLInputElement | HTMLTextAreaElement>) => void;
}

export const CustomFormInput: React.FC<CustomFormInputProps> = ({
  label,
  controlId,
  placeholder,
  register,
  validation,
  error,
  asCol = true,
  onChange,
  value,
  inputType = "text",
  isEditable = true,
  maxLength,
  as,
  rows,
  borderRadius = 12,
  fullWidth,
  width = "95%",
  border = "1px solid var(--gray-color)",
  onKeyDown,
  onInput,
}) => {
  const [inputValue, setInputValue] = useState<string>(String(value));
  const [showPassword, setShowPassword] = useState<boolean>(false);

  useEffect(() => {
    const handler = setTimeout(() => {
      if (onChange) {
        onChange(inputValue);
      }
    }, 500);

    return () => {
      clearTimeout(handler);
    };
  }, [inputValue]);

  return (
    <>
      <style>
        {`
          .custom-form-input::placeholder {
            color: var(--primary-color);
            font-size: 16px;
            font-family : var(--font-krub);
          }
          .custom-form-input::-webkit-input-placeholder {
            color: var(--primary-color);
            font-size: 16px;
            font-family : var(--font-krub);
          }
          .custom-form-input:-ms-input-placeholder {
            color: var(--primary-color);
            font-size: 16px;
            font-family : var(--font-krub);
          }
          .custom-form-input:focus::placeholder {
            color: var(--primary-color);
            font-size: 16px;
            font-family : var(--font-krub);
          }
        `}
      </style>
      {inputType === "password"
        ? (
          <Form.Group
            as={asCol ? Col : "div"}
            {...(asCol ? { xs: 12, md: 4 } : {})}
            style={fullWidth ? { width: width } : {}}
            controlId={controlId}
          >
            {label?.trim() && <Form.Label
              style={{
                color: "var(--primary-color)",
                fontFamily: "var(--font-krub)",
                fontSize: "16px",
                fontWeight: "500",
                marginTop: "10px",
                marginBottom: "10px",
              }}
            >{label}</Form.Label>}

            <div
              style={{
                display: "flex",
                alignItems: "center",
                border: border,
                borderRadius: `${borderRadius}px`,
                backgroundColor: "var(--white-color)",
                height: "2.62rem",
                marginTop: "10px",
                marginBottom: "10px",
                padding: "0",
              }}
            >
              <Form.Control
                type={showPassword ? "text" : "password"}
                placeholder={placeholder}
                {...register(controlId, validation)}
                isInvalid={!!error}
                value={value}
                onChange={(e) => setInputValue(e.target.value)}
                onKeyDown={onKeyDown}
                readOnly={!isEditable}
                maxLength={maxLength}
                onInput={onInput}
                style={{
                  border: "none",
                  borderRadius: "12px",
                  outline: "none",
                  boxShadow: "none",
                  fontSize: "15px",
                  fontWeight: "500",
                  flex: 1,
                  height: "100%",
                  padding: "10px",
                  fontFamily: "var(--font-krub)",
                  color: "var(--primary-color)",
                  backgroundColor: "var(--white-color)",
                }}
              />
              <div
                onClick={() => setShowPassword(!showPassword)}
                style={{
                  height: "100%",
                  width: "40px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  cursor: "pointer",
                }}
              >
                <img
                  src={showPassword ? eye : offEye}
                  width={20}
                />
              </div>
            </div>

            {error && (
              <Form.Control.Feedback type="invalid" style={{ display: "block" }}>
                {error.message}
              </Form.Control.Feedback>
            )}
          </Form.Group>
        ) : (
          <Form.Group
            as={asCol ? Col : "div"}
            {...(asCol ? { xs: 12, md: 4 } : {})}
            style={fullWidth ? { width: width } : {}}
            controlId={controlId}
          >
            {label?.trim() && <Form.Label
              style={{
                color: "var(--primary-color)",
                fontFamily: "var(--font-krub)",
                fontSize: "16px",
                fontWeight: "500",
                marginTop: "10px",
                marginBottom: "10px",
              }}
            >{label}</Form.Label>}
            <Form.Control
              className="custom-form-input"
              type={inputType}
              placeholder={placeholder}
              {...register(controlId, validation)}
              isInvalid={!!error}
              value={value}
              onChange={(e) => setInputValue(e.target.value)}
              onKeyDown={onKeyDown}
              readOnly={!isEditable}
              maxLength={maxLength}
              as={as}
              rows={as === "textarea" ? rows : undefined}
              onInput={onInput}
              style={{
                transition: "border-color 0.3s ease",
                border: border,
                borderRadius: `${borderRadius}px`,
                outline: "none",
                boxShadow: "none",
                fontSize: "15px",
                fontWeight: "500",
                width: "100%",
                height: as !== "textarea" ? "2.62rem" : "auto",
                lineHeight: "24px",
                padding: "10px",
                backgroundColor: "var(--white-color)",
                fontFamily: "var(--font-krub)",
                color: "var(--primary-color)",
                marginBottom: "10px",
                marginTop: "10px"
              }}
            />
            {error && <Form.Control.Feedback type="invalid">{error.message}</Form.Control.Feedback>}
          </Form.Group>
        )}
    </>
  )
};
